<div class="fv2-modal-backdrop cv2-clash" [style.display]="visible === 'none' ? 'none' : ''" (click)="cancel()">
  <div class="fv2-modal cv2-clash-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
    <div class="fv2-modal-head">
      <h3><i class="ph ph-user-minus"></i> {{ 'removeTimeSlot' | translate }}</h3>
      <button type="button" class="fv2-modal-close" (click)="cancel()" aria-label="Close"><i class="ph ph-x"></i></button>
    </div>
    <div class="fv2-modal-body">
      <div class="cv2-clash-info">
        <img *ngIf="staffImage" [src]="staffImage" class="cv2-clash-avatar" alt="" />
        <p class="cv2-clash-message" [innerHtml]="fullMessageHTMLString"></p>
      </div>
      <div class="cv2-clash-question">
        {{ 'doYouWantToClear' | translate }} <b>{{ showTimeSlot }}</b> {{ 'periodIn' | translate }} <b>{{ showClass }}</b>?
      </div>
    </div>
    <div class="fv2-modal-foot">
      <button type="button" class="fv2-btn-ghost" (click)="cancel()">{{ 'cancel' | translate }}</button>
      <button type="button" class="fv2-btn-primary" (click)="removeTimeSlot()">{{ 'yes' | translate }}</button>
    </div>
  </div>
</div>
